import { TCol } from "../../../../components/layout/listing-table/listing-table.types";
import { columnConfiguration } from "./flyer-list-table.configuration";

export const buildColumns = (firstColumnHeader: Partial<TCol>) => {
  const columns = [...columnConfiguration];
  columns[0] = {
    ...columns[0],
    ...firstColumnHeader,
  };

  return columns;
};

export const flyerStatus = (paginationStatus: boolean) =>
  paginationStatus ? "Active" : "Inactive";
